import React from 'react';
import styled from 'styled-components';
import { FaChartLine, FaTasks } from 'react-icons/fa';

const FarmerStatus = () => {
  return (
    <Wrapper>
      <Header>
        <Title>Farmer Status</Title>
      </Header>

      <StatusContainer>
        <StatusCard>
          <CircleContainer borderColor="#4caf50">
            <Percentage>0%</Percentage>
          </CircleContainer>
          <LabelWrapper>
            <FaChartLine size={18} color="#2e7d32" />
            <Label>Active</Label>
          </LabelWrapper>
        </StatusCard>

        <StatusCard>
          <CircleContainer borderColor="#1976d2">
            <Percentage>0%</Percentage>
          </CircleContainer>
          <LabelWrapper>
            <FaTasks size={18} color="#1565c0" />
            <Label>Project Progress</Label>
          </LabelWrapper>
        </StatusCard>
      </StatusContainer>
    </Wrapper>
  );
};

export default FarmerStatus;

const Wrapper = styled.div`
  width: 100%; /* Instead of 50% */
  max-width: 500px; /* Optional limit */
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  padding: 5px;
`;


const Header = styled.div`
  background: linear-gradient(45deg, rgb(13, 207, 55), rgb(13, 110, 9));
  padding: -10px 10px;
  border-radius: 8px 8px 0 0;
`;

const Title = styled.h2`
  font-size: 1.1rem;
  color: #fff;
  font-weight: 600;
  margin: 0;
`;

const StatusContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  justify-content: center;
`;

const StatusCard = styled.div`
  width: 210px;
  border-radius: 12px;
  padding: 4px 10px;
  text-align: center;
  transition: 0.3s;

  &:hover {
    background: #eefaf0;
    transform: translateY(-2px);
  }
`;

const CircleContainer = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 6px solid ${props => props.borderColor || '#4caf50'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

const Percentage = styled.span`
  font-size: 25px;
  font-weight: bold;
  color: #333;
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align to the left */
  margin-left: 8px;         /* Small left spacing from circle if needed */
  margin-top: 10px;
`;


const Label = styled.span`
  font-size: 14px;
  color: #333;
  margin-top: 6px;
`;
